module.exports = __webpack_public_path__ + "img/dashboard.cf2eefa9.svg";